import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextComponent } from '../input-text/input-text.component';
import { MyButtonComponent } from '../../buttons/my-button/my-button.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ErrorService } from 'src/app/core/services/error.service';

@Component({
  selector: 'app-input-number',
  standalone: true,
  imports: [
    CommonModule,
    InputTextComponent,
    MyButtonComponent
  ],
  templateUrl: './input-number.component.html',
  styleUrl: './input-number.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputNumberComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() icon?: string;
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() class: string = '';
  @Input() step: number = 1;
  @Input() min?: number;
  @Input() max?: number;
  @Input() labelError?: string;
  @Input() integer?:boolean;

  // constructor(
  //   private errorService: ErrorService
  // ) { }

  onIncrementClick() {
    let value = (Number(this.form.get(this.name)?.value) || 0) + this.step;
    value = Math.round(value * 1000) / 1000;
    if (!this.max || (this.max && (value <= this.max))) {
      this.form.get(this.name)?.setValue(value);
    }
  }

  onDecrementClick() {
    if(Number(this.form.get(this.name)?.value)<=0 || Number.isNaN(this.form.get(this.name)?.value)){
      return;
    }
    let value = (Number(this.form.get(this.name)?.value) || 0) - this.step;
    value = Math.round(value * 1000) / 1000;
    if (!this.min || (this.min && (value >= this.min))) {
      this.form.get(this.name)?.setValue(value);
    }
  }

  // hasError() {
  //   return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  // }

  // error() {
  //   const errors = Object.entries(
  //     this.form.get(this.name)?.errors || {}
  //   );
  //   return this.errorService.getErrorValidationMessage(this.labelError ?? this.label ?? this.name, errors);
  // }
}
